import {
    COHORTS,
    useCohort,
    useIsStandardToPremiumUpgradeEligible,
    useIsJiraContactCompanyExpandEligible
} from "@/components/user-context/helpers/cohorts";

import { LoggedInJiraNewUser } from "../components/logged-in-jira-new-user";

import { CurrentProductJoinableUser } from "./current-product-joinable-user";
import { CurrentProductUser } from "./current-product-user";
import { LoggedInJiraPremiumExistingUser } from "./existing-user";
import { LoggedInJiraPremiumUpgradeEligibleUser } from "./upgrade-eligible-user";

export const LoggedInJiraPremium = () => {
    const useContactExpandCohortLogic = useIsJiraContactCompanyExpandEligible();
    const isStandardToPremiumUpgradeEligible =
        useIsStandardToPremiumUpgradeEligible();

    const cohort = useCohort(useContactExpandCohortLogic);
    if (cohort === COHORTS.NEW_USER) {
        return <LoggedInJiraNewUser />;
    }

    if (isStandardToPremiumUpgradeEligible) {
        return <LoggedInJiraPremiumUpgradeEligibleUser />;
    }

    if (cohort === COHORTS.UPGRADE_ELIGIBLE_USER) {
        return <LoggedInJiraPremiumUpgradeEligibleUser />;
    }

    if (useContactExpandCohortLogic) {
        if (cohort === COHORTS.CURRENT_PRODUCT_USER) {
            return <CurrentProductUser />;
        }

        if (cohort === COHORTS.CURRENT_PRODUCT_JOINABLE_USER) {
            return <CurrentProductJoinableUser />;
        }

        return <LoggedInJiraNewUser />;
    }

    if (cohort) {
        return <LoggedInJiraPremiumExistingUser />;
    }

    return null;
};
